<template>
  <div class="userProfile">
    <form class="form" @submit.prevent="updateProfile()">
      <div>
      <InputText
        class="box"
        type="text"
        v-model="user.firstname"
        placeholder="First Name"
      />
      </div>
      <div>
      <InputText
        class="box"
        type="text"
        v-model="user.lastname"
        placeholder="Last Name"
      />
      </div>
      <div class="p-input-icon-left">
        <i class="pi pi-user" />
        <InputText
          class="box"
          type="text"
          v-model="user.email"
          placeholder="Email"
        />
      </div>
      <!-- <div class="p-input-icon-left">
        <i class="pi pi-lock" />
        <InputText
          class="box"
          type="password"
          v-model="user.password"
          placeholder="Password"
        />
      </div> -->
      <!-- <InputText
        class="box"
        type="text"
        v-model="user.dod"
        placeholder="Last 6 Digits of DOD ID#"
      /> -->
      <div class="no-edit">
        <label>Last 6 DOD:</label>
        <p>{{user.dod}}</p>
      </div>
      <Button label="Update" type="submit" />
    </form>
    <Toast position="bottom-right" />
  </div>
</template>

<script>
import { fb_db, fs } from "../firebase";

export default {
  name: "UserProfile",
  data() {
    return {

    }
  },
  mounted () {

  },
  methods: {
    updateProfile() {
      fb_db
        .collection("users")
        .doc(this.user.id)
        .update(this.userProfile)
        .then(() => {
          console.log("Profile successfully updated");
          this.$toast.add({
            severity: "success",
            summary: "Updated",
            detail: "Your profile data has been updated.",
            life: 3000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error!",
            detail: error,
            life: 3000,
          });
          console.error("error updating user: ", error);
        });
    },
    confirmDelete() {
      // ask confirmation to delete their own account
    },
    deleteAccount() {
      // if a user wishes to delete their own account
    },
  },

  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
    user() {
      return this.userProfile;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.userProfile {
  max-width: 400px;
  margin: 0 auto;

  .no-edit {
    text-align: left;

    label {
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 600;
    }

    p {
      font-size: 18px;
      font-weight: 600;
      margin: 0;
      margin-bottom: 20px;
    }
  }

  form {
    width: 75%;
    margin: 0 auto;
    max-width: 250px;

    .box {
      margin: 10px 0px;
    }

    .p-input-icon-left {
      width: 100%;
    }

    input {
      width: 100%;
    }
  }

}
</style>